import React from 'react'
import { LayerWrapper } from './LayerStyles'

export default function Layer() {
  return <LayerWrapper />
}
